module.exports = __webpack_public_path__ + "img/download.ba82ddab.svg";